import { RawTemplate } from './types';

export abstract class Template {
    readonly id: string | number;

    /**
     * Template type
     */
    readonly type: string;

    /**
     * Raw HTML of the template
     */
    readonly html: string | null;

    /**
     * Raw CSS of the template
     */
    readonly css: string | null;

    /**
     * Javascript code for the template in string format
     */
    readonly js: string | null;

    /**
     * The template target
     */
    readonly wrapperElement: HTMLElement;

    constructor(template: RawTemplate, wrapperElement: HTMLElement) {
        this.id = template.id;
        this.type = template.type;
        this.html = template.html;
        this.css = template.css;
        this.js = template.js;

        this.wrapperElement = wrapperElement;
    }

    /**
     * All template engines must implement their own rendering process
     */
    abstract render(context: Record<string, unknown>): Promise<void>;
}
